import React from 'react'
import { Box, Heading, Text, Table, Link } from '@workwhile/ui'
import { ColumnDef } from '@tanstack/react-table'
import { useW2WorkItemsInReview } from 'queries/w2/useW2WorkItemsInReview'
import { WorkItemInReview } from 'api/w2/review'

export default function WorkItemsInReview() {
  const { data = [], isLoading, error } = useW2WorkItemsInReview()

  const columns: ColumnDef<WorkItemInReview>[] = [
    {
      header: 'Company',
      accessorFn: (row) => row.companyName || String(row.companyId),
      cell: ({ row }) => (
        <Link to={`/companies/${row.original.companyId}`}>
          {row.original.companyName || row.original.companyId}
        </Link>
      ),
    },
    {
      header: 'Shift',
      accessorKey: 'shiftId',
      cell: ({ row }) => (
        <Link to={`/shifts/${row.original.shiftId}`}>
          {row.original.shiftId}
        </Link>
      ),
    },
    {
      header: 'Worker',
      accessorFn: (row) => row.workerName || String(row.workerId),
      cell: ({ row }) => (
        <Link to={`/users/${row.original.workerId}`}>
          {row.original.workerName || row.original.workerId}
        </Link>
      ),
    },
    { header: 'Work ID', accessorKey: 'workId' },
    { header: 'Status', accessorKey: 'status' },
  ]

  return (
    <Box p={4}>
      <Heading level={2} mb={3}>
        W2 Work Items In Review
      </Heading>
      <Heading level={3} mb={3}>
        ({new Date().toLocaleString('en-US')})
      </Heading>
      {isLoading ? <Text>Loading…</Text> : null}
      {error ? <Text color="error">Failed to load data</Text> : null}
      {!isLoading && !error ? (
        <Table columns={columns} data={data} enableSorting />
      ) : null}
    </Box>
  )
}
